import React from 'react';
import './AboutDescriptions.css';
import ClassRoom from '../../Assets/ClassRoom.png';

function AboutDescriptions() {
  return (
    <div className="about-descriptions-container">
      <div className="about-descriptions-placing">
        <span className="about-descriptions-title">About BeyondSchools</span>
        <p className="about-descriptions-paragraph">
          BeyondSchools is a transformative Tanzanian online learning platform designed to empower students and educators in their pursuit of excellence. Built to address the unique challenges of Tanzania’s secondary education system (Form 1–6), Beyond Schools seamlessly integrates cutting-edge technology with culturally relevant content, bridging the gap between traditional classrooms and modern digital learning. Our platform offers affordable, high-quality educational tools tailored to elevate academic performance for students in both urban centers and underserved rural communities.
        </p>
        
        <p className="about-descriptions-paragraph">
          At BeyondSchools, we are more than a platform—we are a movement. Our mission is to revolutionize Tanzania’s educational landscape by unlocking the full potential of students and teachers alike, creating a future where every learner thrives.
        </p>

        <span className="about-descriptions-min-title">
          <u>Our Vision</u>
        </span>
        <div className='paragraph-section-separator'>
            <p className="about-descriptions-paragraph">
              To create an education platform where every student has the opportunity to thrive, empowering communities and transforming lives through accessible, high-quality learning.
            </p>
        </div>
        
        <span className="about-descriptions-min-title">
          <u>Our Mission</u>
        </span>
        <div className='paragraph-section-separator'>
            <p className="about-descriptions-paragraph">
              To transform Tanzania’s education system and ensure equitable access to quality learning across Africa by empowering students, teachers, and parents through innovative technology, fostering an environment where every learner can succeed and education is limitless.
            </p>
        </div>

        <span className="about-descriptions-min-title">
          <u>Why Choose BeyondSchools?</u>
        </span>
        <p className="about-descriptions-paragraph">
          At BeyondSchools, we’re redefining education in Tanzania by blending innovation, accessibility, and excellence. Here’s why learners, educators, and parents trust us to shape futures:
        </p> 

        <span className="about-descriptions-sub-title">1. On-Demand Learning, Aligned to Excellence</span>
        <p className="about-descriptions-paragraph-min">
          Access a digital treasure trove of curriculum-aligned resources—recorded lessons, quizzes, and past exam papers—directly mapped to the Tanzanian secondary syllabus (TIE-approved). Study smarter, anytime, with materials designed for success. <em>“Your syllabus, your pace, your mastery.”</em>
        </p>

        <span className="about-descriptions-sub-title">2. Live Classes That Ignite Minds</span>
        <p className="about-descriptions-paragraph-min">
          Join real-time, interactive sessions led by Tanzania’s top educators. Collaborate, ask questions, and dive deep into subjects with peers. Learning isn’t passive here—it’s dynamic, engaging, and transformative. <em>“Where curiosity meets expertise.”</em>
        </p>

        <span className="about-descriptions-sub-title">3. Exam Excellence, Guaranteed</span>
        <p className="about-descriptions-paragraph-min">
          Dominate CSEE and ACSEE exams with our targeted boot camps. Master revision strategies, tackle mock exams, and build unshakable confidence. We don’t just teach—we prepare champions. <em>“Your roadmap to top grades.”</em>
        </p>

        <span className="about-descriptions-sub-title">4. Smarter Assessments, Faster Growth</span>
        <p className="about-descriptions-paragraph-min">
          Our AI-powered analytics turn quizzes into actionable insights. Identify gaps, track progress, and refine strategies with instant feedback. Knowledge is power—data makes it unstoppable. <em>“See progress, not just scores.”</em>
        </p>

        <span className="about-descriptions-sub-title">5. Learning Without Limits</span>
        <p className="about-descriptions-paragraph-min">
          Study anytime, anywhere. Our mobile-first platform works seamlessly online or offline, bridging the digital divide for urban and rural learners alike. No internet? No problem. <em>“Education that meets you where you are.”</em>
        </p>

        <span className="about-descriptions-sub-title">6. Skills for Tomorrow’s Leaders</span>
        <p className="about-descriptions-paragraph-min">
          Go beyond textbooks with vocational courses in coding, entrepreneurship, and financial literacy. Equip students with real-world skills to lead, innovate, and thrive in a competitive world. <em>“Building careers, not just graduates.”</em>
        </p>
      </div>
      <img src={ClassRoom} alt="online" className="about-mission" />
    </div>
  );
}

export default AboutDescriptions;
